<div class="w-full h-full flex flex-col items-center justify-center">
    <img src="/assets/images/maintenance.png" alt="Maintenance" class="w-1/2 max-w-[600px] h-auto mb-8" />
    <h1 class="text-white text-xl font-bold">This site is currently undergoing maintenance.</h1>
    <p class="text-white">We apologize for any inconvenience caused.</p>
    <p class="text-white">Please check back in a few hours.</p>
</div>
